const React = require("react");
const noop = require("mn-utils/noop");
const {AdminTableRow} = require("../../../../../../../dumb/TableRow");
const Tooltip = require("../../../../../../../dumb/Tooltip/B");
const Ripple = require("../../../../../../../dumb/Ripple");
const {
  DisplayDataAdmin,
  DisplayHashAdmin,
  DisplayIdAdmin,
  DisplayAddressAdmin,
  DisplayDateTimeAdmin,
  DisplayAmountAdmin
} = require("../../../../../../../dumb/DisplayData");
const {DisplayStatusWithdraw} = require("../../../../../../../dumb/StatusDisplay");

const openPopupWithdrawComplete = require('../../utils/openPopupWithdrawComplete');
const openPopupWithdrawCancel = require('../../utils/openPopupWithdrawCancel');
const openPopupWithdrawReset = require('../../utils/openPopupWithdrawReset');
const openPopupWithdrawProcessingStart = require('../../utils/openPopupWithdrawProcessingStart');

const PaymentIcon = require('./svg/PaymentIcon');
const CheckIcon = require('./svg/CheckIcon');
const TrashIcon = require('./svg/TrashIcon');
const ResetIcon = require('./svg/ResetIcon');
const formatTime = require("mn-utils/formatTime");

module.exports = (props) => {

  const {
    id,
    amount,
    account = {},
    app = {},
    merchant = {},
    cc_code: ccCode,
    created_at: date,
    app_wallet: userWalletData,
    transaction_hash: transactionHash,
    lifeflow: status
  } = props.data;

  const deleteDisabled = status !== 'initiated';
  const completeDisabled = status !== 'initiated';

  const merchantName = (account || {}).name;
  const merchantEmail = (account || {}).login;

  return (
    <AdminTableRow className="f12" index={props.index}>
      <div className="wmin185 fx1 bold">
        <DisplayIdAdmin>{id}</DisplayIdAdmin>
      </div>
      <div className="wmin185 fx1 bold">
        <DisplayDateTimeAdmin date={date} />
      </div>
      <div className="wmin185 fx1 bold">
        <div className="lh13 fw7">
          <DisplayDataAdmin>
            {merchantName}
          </DisplayDataAdmin>
        </div>
        <div className="c717275 lh13 fw4 mt3">
          <DisplayDataAdmin>
            {merchantEmail}
          </DisplayDataAdmin>
        </div>
      </div>
      <div className="wmin185 fx1 bold">
        <DisplayDataAdmin>
          {app.name}
        </DisplayDataAdmin>
      </div>
      <div className="wmin185 fx1 bold">
        <DisplayAddressAdmin>
          {userWalletData.address}
        </DisplayAddressAdmin>
      </div>
      <div className="wmin185 fx1 bold">
        <DisplayAmountAdmin
          amount={amount}
          symbol={ccCode}
          type="coin"
        />
      </div>
      <div className="wmin185 fx1 bold">
        <DisplayHashAdmin>
          {transactionHash}
        </DisplayHashAdmin>
      </div>
      <div className="wmin185 fx1 bold">
        <DisplayStatusWithdraw status={status} />
      </div>
      <div className="wmin240 layoutRow jcC (ph3)>1">
        <div>
          <Tooltip title="Begin Processing" disabledCopy>
            <Ripple
              className="w42 h42 p7 r7 (bgc0.25):h:not[.disabled] o15.disabled"
              onClick={completeDisabled
                ? noop
                : () => openPopupWithdrawProcessingStart(props.data, props.update)
              }
              disabled={completeDisabled}
            >
              <PaymentIcon className="w25 h25 fill3E4044" />
            </Ripple>
          </Tooltip>
        </div>
        <div>
          <Tooltip title="Reset Withdrawal" disabledCopy>
            <Ripple
              className="w42 h42 p7 r7 (bgc0.25):h:not[.disabled] o15.disabled"
              onClick={completeDisabled
                ? noop
                : () => openPopupWithdrawReset(props.data, props.update)
              }
              disabled={completeDisabled}
            >
              <ResetIcon className="w25 h25 fill3E4044" />
            </Ripple>
          </Tooltip>
        </div>
        <div>
          <Tooltip title="Complete Withdrawal" disabledCopy>
            <Ripple
              className="w42 h42 p7 r7 (bgc0.25):h:not[.disabled] o15.disabled"
              onClick={completeDisabled
                ? noop
                : () => openPopupWithdrawComplete(props.data, props.update)
              }
              disabled={completeDisabled}
            >
              <CheckIcon className="w25 h25 fill3E4044" />
            </Ripple>
          </Tooltip>
        </div>
        <div>
          <Tooltip title="Cancel Withdrawal" disabledCopy>
            <Ripple
              className="w42 h42 p7 r7 (bgc0.25):h:not[.disabled] o15.disabled"
              onClick={deleteDisabled
                ? noop
                : () => openPopupWithdrawCancel(props.data, props.update)
              }
              disabled={deleteDisabled}
            >
              <TrashIcon className="w25 h25 fill3E4044" />
            </Ripple>
          </Tooltip>
        </div>
      </div>

    </AdminTableRow>
  )
}
